<head>
    <title>Search as a service</title>
</head>

<router-outlet></router-outlet>


